import axios from "axios";
import React, { useEffect, Suspense, lazy } from "react";
import { get_guest_post_backlink } from "../../../services/constants";
import { extractDomain } from "../../../helperJs/helper";
import { ZustandStore } from "../../../store/zustand-store";
import FallbackLoader from "../../share/components/FallbackLoader";

const SiteTableLazy = lazy(() =>
  import("../../../Adsy/share/components/site/site-table.component")
);
const BacklinkGuestPost = () => {
  const { guest_post_data } = ZustandStore((state) => state);

  const handleGuestPost = async () => {
    try {
      const response = await axios.get(get_guest_post_backlink());
      const data = response?.data?.map((item) => {
        return {
          ...item,
          domain: extractDomain(item.URL),
          interested: false,
          dr: Number(item.DR) || 0,
          traffic: Number(item.Traffic) || 0,
          da: Number(item.DA) || 0,
          cf: 0,
          tf: 0,
          ss: 0,
          price: item.Cost || 0,
          link_type: item.Status,
          categories: item?.Niche
            ? item.Niche.split(/[,/]/)
                .map((c) => c.trim())
                .filter(Boolean)
            : [],
        };
      });
      ZustandStore.setState({
        guest_post_data: {
          data: data,
          loading: false,
          error: false,
        },
      });
    } catch (error) {
      ZustandStore.setState({
        guest_post_data: {
          data: [],
          loading: false,
          error: true,
        },
      });
    }
  };

  useEffect(() => {
    if (guest_post_data.data?.length === 0 && !guest_post_data.error) {
      handleGuestPost();
    }
  }, [guest_post_data]);

  return (
    <>
      <h3 className="heading-small">
        This section matches your domain with{" "}
        <b>the most relevant guest post opportunities</b> based on your niche
        and backlink profile. Instantly purchase or request details for
        publishing your guest post.
      </h3>
      <Suspense fallback={<FallbackLoader />}>
        <SiteTableLazy
          domain={""}
          data={guest_post_data.data || []}
          tableLoader={guest_post_data.loading}
        />
      </Suspense>
    </>
  );
};

export default BacklinkGuestPost;
